var map = {
	"./punto-1.png": "8688",
	"./punto-10.png": "d221",
	"./punto-11.png": "a283",
	"./punto-12.png": "580b",
	"./punto-13.png": "249d",
	"./punto-14.png": "d2d6",
	"./punto-15.png": "16cc",
	"./punto-16.png": "e72f",
	"./punto-17.png": "193e",
	"./punto-2.png": "ea29",
	"./punto-3.png": "67da",
	"./punto-4.png": "0d4a",
	"./punto-5.png": "0ce0",
	"./punto-6.png": "b64c",
	"./punto-7.png": "9282",
	"./punto-8.png": "0e55",
	"./punto-9.png": "16fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9523";